import React from 'react';

export default function AppContact() {
  return (
    <section className='bg-light py-5' id='contact'>
      <div className='container px-5 my-5 px-5'>
        <div className='text-center mb-5'>
          <div className='feature bg-primary bg-gradient text-white rounded-3 mb-3'>
            <i className='bi bi-envelope'></i>
          </div>
          <h2 className='fw-bolder'>Contact Us</h2>
          <p className='lead mb-0'>Michels MFG LLC<br /> 25159 State Highway 64<br /> Canton, TX 75103<br /> (903)340-0682</p>
          <p className='lead mb-0'><strong><a href="mailto:info%40michelsmfg.com">info@michelsmfg.com</a></strong></p>
        </div>
        <div className='row gx-5 justify-content-center'>
          <div className='col-lg-6'>
            <form id='contactForm' data-sb-form-api-token='API_TOKEN'>
              <div className='form-floating mb-3'>
                <input className='form-control' id='name' type='text' placeholder='Enter your name...' data-sb-validations='required' />
                <label htmlFor='name'>Full name</label>
                <div className='invalid-feedback' data-sb-feedback='name:required'>
                  A name is required.
                </div>
              </div>
              <div className='form-floating mb-3'>
                <input className='form-control' id='email' type='email' placeholder='name@example.com' data-sb-validations='required,email' />
                <label htmlFor='email'>Email address</label>
                <div className='invalid-feedback' data-sb-feedback='email:required'>
                  An email is required.
                </div>
                <div className='invalid-feedback' data-sb-feedback='email:email'>
                  Email is not valid.
                </div>
              </div>
              <div className='form-floating mb-3'>
                <input className='form-control' id='phone' type='tel' placeholder='(123) 456-7890' data-sb-validations='required' />
                <label htmlFor='phone'>Phone number</label>
                <div className='invalid-feedback' data-sb-feedback='phone:required'>
                  A phone number is required.
                </div>
              </div>
              {/* <div className="form-floating mb-3">
                            <textarea className="form-control" id="message" type="text" placeholder="Enter your message here..." style="height: 10rem" data-sb-validations="required"></textarea>
                            <label htmlFor="message">Message</label>
                            <div className="invalid-feedback" data-sb-feedback="message:required">A message is required.</div>
                        </div> */}

              <div className='d-none' id='submitSuccessMessage'>
                <div className='text-center mb-3'>
                  <div className='fw-bolder'>Form submission successful!</div>
                  To activate this form, sign up at
                  <br />
                  <a href='https://startbootstrap.com/solution/contact-forms'>https://startbootstrap.com/solution/contact-forms</a>
                </div>
              </div>

              <div className='d-none' id='submitErrorMessage'>
                <div className='text-center text-danger mb-3'>Error sending message!</div>
              </div>

              <div className='d-grid'>
                <button className='btn btn-primary btn-lg disabled' id='submitButton' type='submit'>
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}
/* 

Michels MFG LLC
25159 State Highway 64
Canton, TX 75103
(903)340-0682 */
